export function registerGeneralSocketListeners(socket) {
  socket.on("ping", (payload, callback) => {
    callback({
      responseAt: new Date()
    });
  });
}